import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-start" };
const _hoisted_2 = { class: "text-start" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResourceGroupListRow',
    props: {
        resourceGroup: { type: Object, required: true }
    },
    setup(__props) {
        const props = __props;
        function getResources() {
            return props.resourceGroup.resources?.map(r => r.name).join(', ') || '';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_1, _toDisplayString(__props.resourceGroup.id), 1),
                _createElementVNode("td", _hoisted_2, _toDisplayString(__props.resourceGroup.name), 1),
                _createElementVNode("td", null, _toDisplayString(getResources()), 1)
            ]));
        };
    }
});
